import React from 'react';
import { Link } from 'react-router-dom';

interface AlertsTabProps {
  alerts: any[];
  onItemSelect?: (item: any) => void;
}

const AlertsTab: React.FC<AlertsTabProps> = ({ alerts, onItemSelect }) => {
  const getPriorityColor = (priority: string) => {
    switch (priority) {
      case 'High':
        return 'text-danger';
      case 'Medium':
        return 'text-warning';
      case 'Low':
        return 'text-success';
      default:
        return 'text-secondary';
    }
  };

  const getAlertIcon = (priority: string) => {
    switch (priority) {
      case 'High':
        return 'ti ti-alert-triangle';
      case 'Medium':
        return 'ti ti-alert-circle';
      case 'Low':
        return 'ti ti-info-circle';
      default:
        return 'ti ti-bell';
    }
  };

  if (alerts.length === 0) {
    return (
      <div className="text-center py-5">
        <div className="d-flex flex-column align-items-center">
          <i className="ti ti-bell-off fs-48 text-muted mb-3"></i>
          <h5 className="text-muted">No Alerts</h5>
          <p className="text-muted">You don't have any active alerts.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="row">
      {alerts.map((alert) => (
        <div key={alert.id} className="col-12 mb-3">
          <div className={`alert alert-${alert.priority === 'High' ? 'danger' : alert.priority === 'Medium' ? 'warning' : 'info'} d-flex align-items-start`}>
            <div className="me-3">
              <i className={`${getAlertIcon(alert.priority)} fs-20`}></i>
            </div>
            <div className="flex-grow-1">
              <div className="d-flex align-items-center justify-content-between mb-2">
                <h6 className="alert-heading mb-0">
                  {alert.subject}
                </h6>
                <small className="text-muted">{alert.sentDate}</small>
              </div>
              <div className="d-flex align-items-center justify-content-between">
                <div>
                  <small className="text-muted">From: {alert.from}</small>
                  <span className={`badge ms-2 ${alert.priority === 'High' ? 'bg-danger' : alert.priority === 'Medium' ? 'bg-warning' : 'bg-info'}`}>
                    {alert.priority} Priority
                  </span>
                </div>
                <div className="d-flex gap-2">
                  <button 
                    className="btn btn-sm btn-outline-secondary"
                    onClick={() => onItemSelect && onItemSelect(alert)}
                    title="View Details"
                  >
                    <i className="ti ti-eye"></i>
                  </button>
                  <button 
                    className="btn btn-sm btn-outline-success"
                    title="Acknowledge"
                  >
                    <i className="ti ti-check"></i>
                  </button>
                  <button 
                    className="btn btn-sm btn-outline-danger"
                    title="Dismiss"
                  >
                    <i className="ti ti-x"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AlertsTab;